<template>
  <div class="no_fly_data">
    <div class="wrap">
      <div class="no_data_img"></div>
      <p class="p1">未获取到飞行轨迹</p>
      <p class="p2">
        如有疑问请联系：<a href="tel: 0571-57888678"> 0571-57888678</a>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "no_fly_data",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  destroyed() {},
  methods: {}
};
</script>
<style lang="stylus" scoped>
.no_fly_data
  width 100%
  height 100%
  position relative
  background #000
  .wrap
    position absolute
    left 0
    right 0
    top 45%
    transform translateY(-50%)
  .no_data_img
    width 134px
    height 87px
    background url('./no_data.png') no-repeat
    background-size 100% 100%
    background-position center center
    margin 0 auto 25px
  p
    color #fff
    text-align center
    font-size 14px
    font-family: Microsoft YaHei;
    line-height 24px
    a
      color #fff
      display inline
</style>
